import { observable } from 'mobx'

class GameLibraryStore {
  @observable
  /** 当前游戏库列表选择的游戏 */
  currentGameLibraryGame: Omit<GameLibraryGame, 'membersToAdd'> | null = null
  @observable
  /** 当前游戏库详情的缓存 */
  currentGameStartInfo: Tools.KeyValueProp<GamePlayInfo> = {}

  @observable
  /** 当前游戏运行状态 */
  gameRunStatus: 'stop' | 'starting' | 'running' | 'waitClose' = 'stop'

  @observable
  /** 当前正在运行的游戏 */
  currentTheRunningGameInfo: GameStartPayload | null = null

  @observable
  /** 当前正准备启动的游戏 */
  currentTheStartingGameInfo: (GameStartPayload & Omit<GameLibraryGame, 'membersToAdd'>) | null = null

  @observable
  gameStartingTimer: number | null = null

  /** 启动游戏超时倒计时 */
  @observable
  gameStartingCountdown: number = 0

  /** 是否需要重新加载游戏启动信息 */
  @observable
  refreshGameStartInfo: number = 0

  /** 当前等待上一个游戏结束之后要启动的游戏 */
  @observable
  willStartGameId?: string | number | null = null

  /** 从支付成功页跳转过去，选中的账号 */
  @observable
  currentSelectedAccount: { gameLibraryId: number; userGameId: number } | null = null
}

export default new GameLibraryStore()
